var map = {
	"./": 29014,
	"./App": 4087,
	"./App.tsx": 4087,
	"./Auth/components/AuthHelpers": 96829,
	"./Auth/components/AuthHelpers.ts": 96829,
	"./Auth/components/AuthProvider": 22185,
	"./Auth/components/AuthProvider.tsx": 22185,
	"./Auth/components/PermissionGate": 72616,
	"./Auth/components/PermissionGate.tsx": 72616,
	"./Auth/data": 98881,
	"./Auth/data.ts": 98881,
	"./Auth/utils/AuthTypes": 10596,
	"./Auth/utils/AuthTypes.ts": 10596,
	"./Auth/utils/Authorizer": 84240,
	"./Auth/utils/Authorizer.ts": 84240,
	"./Auth/utils/DataModel": 11810,
	"./Auth/utils/DataModel.ts": 11810,
	"./Auth/utils/GetAuthMiddleware": 88251,
	"./Auth/utils/GetAuthMiddleware.tsx": 88251,
	"./Auth/utils/demologin": 95503,
	"./Auth/utils/demologin.ts": 95503,
	"./Auth/utils/interfaces": 80059,
	"./Auth/utils/interfaces.ts": 80059,
	"./BaseLayout/assets/fonts/titillium-bold.ttf": 30830,
	"./BaseLayout/assets/fonts/titillium-bold.woff": 40526,
	"./BaseLayout/assets/fonts/titillium-italic.ttf": 50239,
	"./BaseLayout/assets/fonts/titillium-italic.woff": 82957,
	"./BaseLayout/assets/fonts/titillium-light.ttf": 39269,
	"./BaseLayout/assets/fonts/titillium-light.woff": 89403,
	"./BaseLayout/assets/fonts/titillium-regular.ttf": 91885,
	"./BaseLayout/assets/fonts/titillium-regular.woff": 80355,
	"./BaseLayout/assets/fonts/titillum.css": 12041,
	"./BaseLayout/assets/img/error/error-404.svg": 10440,
	"./BaseLayout/assets/img/error/error-500.svg": 45005,
	"./BaseLayout/assets/img/grunge.png": 59351,
	"./Intl/data": 48178,
	"./Intl/data.ts": 48178,
	"./Intl/language-picker": 90417,
	"./Intl/language-picker.tsx": 90417,
	"./Intl/utils": 86461,
	"./Intl/utils.ts": 86461,
	"./Settings/PageValidations": 32323,
	"./Settings/PageValidations.ts": 32323,
	"./Settings/calender-locales": 88532,
	"./Settings/calender-locales.ts": 88532,
	"./Settings/citation-settings": 73591,
	"./Settings/citation-settings.ts": 73591,
	"./Settings/config": 25958,
	"./Settings/config.ts": 25958,
	"./Settings/data": 96820,
	"./Settings/data.ts": 96820,
	"./Settings/emptyModels": 36033,
	"./Settings/emptyModels.ts": 36033,
	"./Settings/externs/data": 38024,
	"./Settings/externs/data.ts": 38024,
	"./Settings/externs/img/arxiv_icon.svg": 59168,
	"./Settings/externs/img/crossref_icon.svg": 79823,
	"./Settings/externs/img/doi_icon.svg": 88066,
	"./Settings/externs/img/gnd_icon.svg": 88929,
	"./Settings/externs/img/grid_icon.png": 42861,
	"./Settings/externs/img/hbz_icon.gif": 81578,
	"./Settings/externs/img/isbn_icon.svg": 91902,
	"./Settings/externs/img/ismn_icon.gif": 28653,
	"./Settings/externs/img/isni_icon.gif": 43911,
	"./Settings/externs/img/issn_icon.svg": 33431,
	"./Settings/externs/img/openAlex_icon.svg": 88610,
	"./Settings/externs/img/orcid_icon.svg": 45973,
	"./Settings/externs/img/pmid_icon.png": 40835,
	"./Settings/externs/img/ringgold_icon.png": 2641,
	"./Settings/externs/img/ror_icon.svg": 47001,
	"./Settings/externs/img/scopus_icon.svg": 74771,
	"./Settings/externs/img/wos_icon.png": 35546,
	"./Settings/externs/img/zdb_icon.png": 62293,
	"./Settings/img/banners/edit/organisation.svg": 32919,
	"./Settings/img/banners/edit/person.svg": 97742,
	"./Settings/img/banners/edit/project.svg": 10220,
	"./Settings/img/banners/edit/work.svg": 33814,
	"./Settings/img/banners/publig.svg": 80705,
	"./Settings/img/banners/search/organisation.svg": 76995,
	"./Settings/img/banners/search/person.svg": 35842,
	"./Settings/img/banners/search/project.svg": 15192,
	"./Settings/img/banners/search/work.svg": 62978,
	"./Settings/img/homepage/orcid-link": 46839,
	"./Settings/img/homepage/orcid-link.tsx": 46839,
	"./Settings/img/homepage/publication-embed": 43155,
	"./Settings/img/homepage/publication-embed.tsx": 43155,
	"./Settings/img/homepage/work-report": 55255,
	"./Settings/img/homepage/work-report.tsx": 55255,
	"./Settings/img/logos/grid.svg": 72349,
	"./Settings/img/logos/logo_orcid.svg": 25324,
	"./Settings/mandants/getBanner": 71543,
	"./Settings/mandants/getBanner.ts": 71543,
	"./Settings/mandants/hhu/banner.png": 23250,
	"./Settings/mandants/hhu/data-homepage": 1143,
	"./Settings/mandants/hhu/data-homepage.json": 1143,
	"./Settings/mandants/hhu/data-page": 45172,
	"./Settings/mandants/hhu/data-page.json": 45172,
	"./Settings/mandants/hhu/data-publig-doc": 17981,
	"./Settings/mandants/hhu/data-publig-doc.json": 17981,
	"./Settings/mandants/hhu/data-statistics": 70292,
	"./Settings/mandants/hhu/data-statistics.json": 70292,
	"./Settings/mandants/hhu/icon.svg": 90096,
	"./Settings/mandants/hhu/logo.svg": 50806,
	"./Settings/mandants/hhu/logo_footer.svg": 6236,
	"./Settings/mandants/mandant-settings": 60452,
	"./Settings/mandants/mandant-settings.ts": 60452,
	"./Settings/mandants/ril/banner.jpg": 52982,
	"./Settings/mandants/ril/data-homepage": 34347,
	"./Settings/mandants/ril/data-homepage.json": 34347,
	"./Settings/mandants/ril/data-page": 27936,
	"./Settings/mandants/ril/data-page.json": 27936,
	"./Settings/mandants/ril/data-publig-doc": 13145,
	"./Settings/mandants/ril/data-publig-doc.json": 13145,
	"./Settings/mandants/ril/data-statistics": 86808,
	"./Settings/mandants/ril/data-statistics.json": 86808,
	"./Settings/mandants/ril/favicon.png": 74154,
	"./Settings/mandants/ril/icon.png": 70463,
	"./Settings/mandants/ril/logo-footer.svg": 29374,
	"./Settings/mandants/ril/logo.svg": 75798,
	"./Settings/mandants/rub/banner.svg": 7303,
	"./Settings/mandants/rub/data-homepage": 89905,
	"./Settings/mandants/rub/data-homepage.json": 89905,
	"./Settings/mandants/rub/data-page": 98954,
	"./Settings/mandants/rub/data-page.json": 98954,
	"./Settings/mandants/rub/data-publig-doc": 37751,
	"./Settings/mandants/rub/data-publig-doc.json": 37751,
	"./Settings/mandants/rub/data-statistics": 75710,
	"./Settings/mandants/rub/data-statistics.json": 75710,
	"./Settings/mandants/rub/icon.svg": 42198,
	"./Settings/mandants/rub/logo.svg": 88668,
	"./Settings/mandants/tudo/banner.png": 90605,
	"./Settings/mandants/tudo/data-homepage": 92258,
	"./Settings/mandants/tudo/data-homepage.json": 92258,
	"./Settings/mandants/tudo/data-page": 32205,
	"./Settings/mandants/tudo/data-page.json": 32205,
	"./Settings/mandants/tudo/data-publig-doc": 42608,
	"./Settings/mandants/tudo/data-publig-doc.json": 42608,
	"./Settings/mandants/tudo/data-statistics": 9577,
	"./Settings/mandants/tudo/data-statistics.json": 9577,
	"./Settings/mandants/tudo/icon.svg": 1667,
	"./Settings/mandants/tudo/logo.svg": 35405,
	"./Settings/mandants/uwh/banner.jpeg": 73362,
	"./Settings/mandants/uwh/data-homepage": 37452,
	"./Settings/mandants/uwh/data-homepage.json": 37452,
	"./Settings/mandants/uwh/data-page": 92043,
	"./Settings/mandants/uwh/data-page.json": 92043,
	"./Settings/mandants/uwh/data-publig-doc": 87098,
	"./Settings/mandants/uwh/data-publig-doc.json": 87098,
	"./Settings/mandants/uwh/data-statistics": 31907,
	"./Settings/mandants/uwh/data-statistics.json": 31907,
	"./Settings/mandants/uwh/icon.svg": 89875,
	"./Settings/mandants/uwh/logo.svg": 73693,
	"./Settings/mathjax-config": 42770,
	"./Settings/mathjax-config.ts": 42770,
	"./Settings/orcid": 27209,
	"./Settings/orcid.ts": 27209,
	"./Settings/pubtype-mappings": 74757,
	"./Settings/pubtype-mappings.ts": 74757,
	"./Settings/search/organisation-facets": 58814,
	"./Settings/search/organisation-facets.ts": 58814,
	"./Settings/search/person-facets": 12839,
	"./Settings/search/person-facets.ts": 12839,
	"./Settings/search/project-facets": 18883,
	"./Settings/search/project-facets.ts": 18883,
	"./Settings/search/work-facets": 65077,
	"./Settings/search/work-facets.tsx": 65077,
	"./Settings/test-settings": 86932,
	"./Settings/test-settings.ts": 86932,
	"./Settings/user-config": 86030,
	"./Settings/user-config.ts": 86030,
	"./Settings/validationWorkEntityMapping": 48487,
	"./Settings/validationWorkEntityMapping.ts": 48487,
	"./Settings/work-page-components-mapping": 3305,
	"./Settings/work-page-components-mapping.ts": 3305,
	"./Vocabulary/components/Notation": 74384,
	"./Vocabulary/components/Notation.tsx": 74384,
	"./Vocabulary/components/Vocabulary": 84542,
	"./Vocabulary/components/Vocabulary.tsx": 84542,
	"./Vocabulary/data": 24819,
	"./Vocabulary/data.ts": 24819,
	"./Vocabulary/gen_vocabulary": 38704,
	"./Vocabulary/gen_vocabulary.ts": 38704,
	"./Vocabulary/util": 69239,
	"./Vocabulary/util.ts": 69239,
	"./api/admin": 33525,
	"./api/admin/": 33525,
	"./api/admin/apis": 57447,
	"./api/admin/apis/": 57447,
	"./api/admin/apis/ImageServiceApi": 44671,
	"./api/admin/apis/ImageServiceApi.ts": 44671,
	"./api/admin/apis/RoleServiceApi": 26402,
	"./api/admin/apis/RoleServiceApi.ts": 26402,
	"./api/admin/apis/SuggestApi": 23793,
	"./api/admin/apis/SuggestApi.ts": 23793,
	"./api/admin/apis/UsersServiceApi": 69618,
	"./api/admin/apis/UsersServiceApi.ts": 69618,
	"./api/admin/apis/index": 57447,
	"./api/admin/apis/index.ts": 57447,
	"./api/admin/docs/ImageServiceApi.md": 23444,
	"./api/admin/docs/OrcidAuthorizeDTO.md": 58151,
	"./api/admin/docs/OrcidPutCodeDTO.md": 26158,
	"./api/admin/docs/OrcidScopeDTO.md": 67334,
	"./api/admin/docs/PageMetadata.md": 57792,
	"./api/admin/docs/PageUsersDTO.md": 75184,
	"./api/admin/docs/PageableObject.md": 7150,
	"./api/admin/docs/PagedModelRoleDTO.md": 51179,
	"./api/admin/docs/PagedModelUsersDTO.md": 4233,
	"./api/admin/docs/PatchDocument.md": 47583,
	"./api/admin/docs/RoleDTO.md": 55113,
	"./api/admin/docs/RoleServiceApi.md": 46307,
	"./api/admin/docs/SortObject.md": 92321,
	"./api/admin/docs/SuggestApi.md": 37112,
	"./api/admin/docs/UsersDTO.md": 62767,
	"./api/admin/docs/UsersServiceApi.md": 1369,
	"./api/admin/index": 33525,
	"./api/admin/index.ts": 33525,
	"./api/admin/models": 9124,
	"./api/admin/models/": 9124,
	"./api/admin/models/OrcidAuthorizeDTO": 82727,
	"./api/admin/models/OrcidAuthorizeDTO.ts": 82727,
	"./api/admin/models/OrcidPutCodeDTO": 70922,
	"./api/admin/models/OrcidPutCodeDTO.ts": 70922,
	"./api/admin/models/OrcidScopeDTO": 35946,
	"./api/admin/models/OrcidScopeDTO.ts": 35946,
	"./api/admin/models/PageMetadata": 99856,
	"./api/admin/models/PageMetadata.ts": 99856,
	"./api/admin/models/PageUsersDTO": 40352,
	"./api/admin/models/PageUsersDTO.ts": 40352,
	"./api/admin/models/PageableObject": 82906,
	"./api/admin/models/PageableObject.ts": 82906,
	"./api/admin/models/PagedModelRoleDTO": 28331,
	"./api/admin/models/PagedModelRoleDTO.ts": 28331,
	"./api/admin/models/PagedModelUsersDTO": 46149,
	"./api/admin/models/PagedModelUsersDTO.ts": 46149,
	"./api/admin/models/PatchDocument": 58599,
	"./api/admin/models/PatchDocument.ts": 58599,
	"./api/admin/models/RoleDTO": 87173,
	"./api/admin/models/RoleDTO.ts": 87173,
	"./api/admin/models/SortObject": 6893,
	"./api/admin/models/SortObject.ts": 6893,
	"./api/admin/models/UsersDTO": 36823,
	"./api/admin/models/UsersDTO.ts": 36823,
	"./api/admin/models/index": 9124,
	"./api/admin/models/index.ts": 9124,
	"./api/admin/runtime": 7613,
	"./api/admin/runtime.ts": 7613,
	"./api/core": 65741,
	"./api/core/": 65741,
	"./api/core/apis": 34223,
	"./api/core/apis/": 34223,
	"./api/core/apis/DeletionTrackingApi": 84294,
	"./api/core/apis/DeletionTrackingApi.ts": 84294,
	"./api/core/apis/HierarchyApi": 68702,
	"./api/core/apis/HierarchyApi.ts": 68702,
	"./api/core/apis/IndexApi": 94955,
	"./api/core/apis/IndexApi.ts": 94955,
	"./api/core/apis/OrganisationApi": 36793,
	"./api/core/apis/OrganisationApi.ts": 36793,
	"./api/core/apis/PersonApi": 67772,
	"./api/core/apis/PersonApi.ts": 67772,
	"./api/core/apis/ProjectApi": 52152,
	"./api/core/apis/ProjectApi.ts": 52152,
	"./api/core/apis/PublisherApi": 57071,
	"./api/core/apis/PublisherApi.ts": 57071,
	"./api/core/apis/PublistConfigApi": 28844,
	"./api/core/apis/PublistConfigApi.ts": 28844,
	"./api/core/apis/PublistCslApi": 36814,
	"./api/core/apis/PublistCslApi.ts": 36814,
	"./api/core/apis/PublistKeyApi": 56525,
	"./api/core/apis/PublistKeyApi.ts": 56525,
	"./api/core/apis/PublistListApi": 68362,
	"./api/core/apis/PublistListApi.ts": 68362,
	"./api/core/apis/PublistShareApi": 36369,
	"./api/core/apis/PublistShareApi.ts": 36369,
	"./api/core/apis/SearchApi": 52503,
	"./api/core/apis/SearchApi.ts": 52503,
	"./api/core/apis/StatsApi": 80194,
	"./api/core/apis/StatsApi.ts": 80194,
	"./api/core/apis/SuggestApi": 72937,
	"./api/core/apis/SuggestApi.ts": 72937,
	"./api/core/apis/WorkApi": 38340,
	"./api/core/apis/WorkApi.ts": 38340,
	"./api/core/apis/index": 34223,
	"./api/core/apis/index.ts": 34223,
	"./api/core/docs/AdminDataOrganisationDTO.md": 58430,
	"./api/core/docs/AdminDataPersonDTO.md": 30307,
	"./api/core/docs/AdminDataProjectDTO.md": 58387,
	"./api/core/docs/AdminDataWorkAgencyGrantIdDTO.md": 46355,
	"./api/core/docs/AdminDataWorkDTO.md": 43947,
	"./api/core/docs/AdminDataWorkGrantAgencyDTO.md": 71262,
	"./api/core/docs/AdminDataWorkGrantDTO.md": 96595,
	"./api/core/docs/AdminDataWorkOpenAccessDTO.md": 29713,
	"./api/core/docs/AdminDataWorkOpenAccessFundedDTO.md": 90543,
	"./api/core/docs/AdminDataWorkOrcidSyncDTO.md": 47037,
	"./api/core/docs/ConfigResponse.md": 83225,
	"./api/core/docs/Csl.md": 66892,
	"./api/core/docs/DatePeriod.md": 79053,
	"./api/core/docs/DeletionTrackingApi.md": 9887,
	"./api/core/docs/DeletionTrackingEntryDTO.md": 23618,
	"./api/core/docs/EmploymentPeriodDTO.md": 35578,
	"./api/core/docs/EventDTO.md": 61389,
	"./api/core/docs/EventPlaceDTO.md": 51926,
	"./api/core/docs/ExternalIdDTO.md": 33573,
	"./api/core/docs/Hierarchy.md": 46549,
	"./api/core/docs/HierarchyApi.md": 20589,
	"./api/core/docs/IndexApi.md": 41304,
	"./api/core/docs/ModelDate.md": 30727,
	"./api/core/docs/Name.md": 5343,
	"./api/core/docs/OrganisationApi.md": 6292,
	"./api/core/docs/OrganisationDTO.md": 18949,
	"./api/core/docs/OrganisationInstitutionalIdDTO.md": 42393,
	"./api/core/docs/OrganisationOtherNameDTO.md": 72836,
	"./api/core/docs/OrganisationToPersonDTO.md": 94837,
	"./api/core/docs/PageMetadata.md": 85718,
	"./api/core/docs/PageResponseListWorkDTO.md": 68228,
	"./api/core/docs/PagedModelConfigResponse.md": 5491,
	"./api/core/docs/PagedModelPublisherDTO.md": 74303,
	"./api/core/docs/PagedModelPublistMetadata.md": 73582,
	"./api/core/docs/PagedModelWorkDTO.md": 77790,
	"./api/core/docs/PatchDocument.md": 18021,
	"./api/core/docs/PersonApi.md": 68541,
	"./api/core/docs/PersonDTO.md": 61644,
	"./api/core/docs/PersonEmailDTO.md": 22084,
	"./api/core/docs/PersonInstitutionalIdDTO.md": 65970,
	"./api/core/docs/PersonNameDTO.md": 54201,
	"./api/core/docs/PersonStatusDTO.md": 28650,
	"./api/core/docs/PersonToOrganisationDTO.md": 61417,
	"./api/core/docs/ProjectApi.md": 50923,
	"./api/core/docs/ProjectDTO.md": 51406,
	"./api/core/docs/ProjectFundingReferenceDTO.md": 23516,
	"./api/core/docs/ProjectFundingReferenceExternalIdentifierDTO.md": 62952,
	"./api/core/docs/ProjectFundingReferenceFundingStreamDTO.md": 58843,
	"./api/core/docs/ProjectFundingReferenceFundingSubstreamDTO.md": 75083,
	"./api/core/docs/ProjectInstitutionalIdDTO.md": 7608,
	"./api/core/docs/ProjectOtherNameDTO.md": 82157,
	"./api/core/docs/ProjectOtherPartnerDTO.md": 49238,
	"./api/core/docs/ProjectPersonOtherDTO.md": 76725,
	"./api/core/docs/ProjectToPersonDTO.md": 64502,
	"./api/core/docs/PubListConfig.md": 41091,
	"./api/core/docs/PubListConfigReplacements.md": 44826,
	"./api/core/docs/PublisherApi.md": 98492,
	"./api/core/docs/PublisherDTO.md": 21197,
	"./api/core/docs/PublistConfigApi.md": 16695,
	"./api/core/docs/PublistConfigProjectOrganisation.md": 32080,
	"./api/core/docs/PublistCslApi.md": 70255,
	"./api/core/docs/PublistKeyApi.md": 19832,
	"./api/core/docs/PublistListApi.md": 82089,
	"./api/core/docs/PublistMetadata.md": 36136,
	"./api/core/docs/PublistShareApi.md": 92756,
	"./api/core/docs/ReferencedOrganisationDTO.md": 31532,
	"./api/core/docs/ReferencedPersonDTO.md": 7941,
	"./api/core/docs/ReferencedPersonNameDTO.md": 84168,
	"./api/core/docs/ReferencedProjectDTO.md": 95321,
	"./api/core/docs/ReferencedWorkDTO.md": 10341,
	"./api/core/docs/SearchApi.md": 84158,
	"./api/core/docs/SearchFacet.md": 4585,
	"./api/core/docs/SearchRequest.md": 63935,
	"./api/core/docs/SearchRequestSort.md": 26511,
	"./api/core/docs/Share.md": 42709,
	"./api/core/docs/ShareRequestBody.md": 76952,
	"./api/core/docs/SolrDocument.md": 81157,
	"./api/core/docs/SolrOrganisationReduced.md": 19046,
	"./api/core/docs/SolrPersonReduced.md": 81467,
	"./api/core/docs/SolrProjectReduced.md": 20185,
	"./api/core/docs/SolrPublisher.md": 96894,
	"./api/core/docs/SolrResultSolrOrganisationReduced.md": 44185,
	"./api/core/docs/SolrResultSolrPersonReduced.md": 55352,
	"./api/core/docs/SolrResultSolrProjectReduced.md": 60560,
	"./api/core/docs/SolrResultSolrPublisher.md": 14949,
	"./api/core/docs/SolrResultSolrWorkReduced.md": 82968,
	"./api/core/docs/SolrWorkReduced.md": 64155,
	"./api/core/docs/StatsApi.md": 9289,
	"./api/core/docs/SubjectDTO.md": 92141,
	"./api/core/docs/SuggestApi.md": 4498,
	"./api/core/docs/UrlDTO.md": 36470,
	"./api/core/docs/WorkApi.md": 4101,
	"./api/core/docs/WorkDTO.md": 75572,
	"./api/core/docs/WorkDateTypeDTO.md": 76480,
	"./api/core/docs/WorkDescriptionDTO.md": 79970,
	"./api/core/docs/WorkGeoLocationDTO.md": 52326,
	"./api/core/docs/WorkGeoLocationPointDTO.md": 37356,
	"./api/core/docs/WorkGeoLocationPolygonDTO.md": 73532,
	"./api/core/docs/WorkHasPartDTO.md": 3031,
	"./api/core/docs/WorkIsPartOfDTO.md": 10412,
	"./api/core/docs/WorkIsPartOfOtherDTO.md": 18594,
	"./api/core/docs/WorkKeywordDTO.md": 10209,
	"./api/core/docs/WorkLanguageDTO.md": 65298,
	"./api/core/docs/WorkOrganisationDTO.md": 37066,
	"./api/core/docs/WorkOrganisationOtherDTO.md": 78132,
	"./api/core/docs/WorkOtherTitleDTO.md": 2840,
	"./api/core/docs/WorkPersonDTO.md": 94855,
	"./api/core/docs/WorkPersonOtherDTO.md": 67447,
	"./api/core/docs/WorkPlaceDTO.md": 73889,
	"./api/core/docs/WorkProjectDTO.md": 28047,
	"./api/core/docs/WorkProjectOtherDTO.md": 17199,
	"./api/core/docs/WorkPublisherDTO.md": 40620,
	"./api/core/docs/WorkPublisherPlaceDTO.md": 30137,
	"./api/core/docs/WorkRelatedIdentifierDTO.md": 83188,
	"./api/core/docs/WorkRelatedIdentifierInternalDTO.md": 99419,
	"./api/core/docs/WorkTitleAbbreviationDTO.md": 73314,
	"./api/core/docs/YearPeriod.md": 75620,
	"./api/core/index": 65741,
	"./api/core/index.ts": 65741,
	"./api/core/models": 5004,
	"./api/core/models/": 5004,
	"./api/core/models/AdminDataOrganisationDTO": 4352,
	"./api/core/models/AdminDataOrganisationDTO.ts": 4352,
	"./api/core/models/AdminDataPersonDTO": 82821,
	"./api/core/models/AdminDataPersonDTO.ts": 82821,
	"./api/core/models/AdminDataProjectDTO": 193,
	"./api/core/models/AdminDataProjectDTO.ts": 193,
	"./api/core/models/AdminDataWorkAgencyGrantIdDTO": 42633,
	"./api/core/models/AdminDataWorkAgencyGrantIdDTO.ts": 42633,
	"./api/core/models/AdminDataWorkDTO": 88229,
	"./api/core/models/AdminDataWorkDTO.ts": 88229,
	"./api/core/models/AdminDataWorkGrantAgencyDTO": 51208,
	"./api/core/models/AdminDataWorkGrantAgencyDTO.ts": 51208,
	"./api/core/models/AdminDataWorkGrantDTO": 12765,
	"./api/core/models/AdminDataWorkGrantDTO.ts": 12765,
	"./api/core/models/AdminDataWorkOpenAccessDTO": 15567,
	"./api/core/models/AdminDataWorkOpenAccessDTO.ts": 15567,
	"./api/core/models/AdminDataWorkOpenAccessFundedDTO": 90665,
	"./api/core/models/AdminDataWorkOpenAccessFundedDTO.ts": 90665,
	"./api/core/models/AdminDataWorkOrcidSyncDTO": 47,
	"./api/core/models/AdminDataWorkOrcidSyncDTO.ts": 47,
	"./api/core/models/ConfigResponse": 7503,
	"./api/core/models/ConfigResponse.ts": 7503,
	"./api/core/models/Csl": 68882,
	"./api/core/models/Csl.ts": 68882,
	"./api/core/models/DatePeriod": 49131,
	"./api/core/models/DatePeriod.ts": 49131,
	"./api/core/models/DeletionTrackingEntryDTO": 45888,
	"./api/core/models/DeletionTrackingEntryDTO.ts": 45888,
	"./api/core/models/EmploymentPeriodDTO": 16168,
	"./api/core/models/EmploymentPeriodDTO.ts": 16168,
	"./api/core/models/EventDTO": 10879,
	"./api/core/models/EventDTO.ts": 10879,
	"./api/core/models/EventPlaceDTO": 53440,
	"./api/core/models/EventPlaceDTO.ts": 53440,
	"./api/core/models/ExternalIdDTO": 16123,
	"./api/core/models/ExternalIdDTO.ts": 16123,
	"./api/core/models/Hierarchy": 35147,
	"./api/core/models/Hierarchy.ts": 35147,
	"./api/core/models/ModelDate": 37881,
	"./api/core/models/ModelDate.ts": 37881,
	"./api/core/models/Name": 29053,
	"./api/core/models/Name.ts": 29053,
	"./api/core/models/OrganisationDTO": 89519,
	"./api/core/models/OrganisationDTO.ts": 89519,
	"./api/core/models/OrganisationInstitutionalIdDTO": 89927,
	"./api/core/models/OrganisationInstitutionalIdDTO.ts": 89927,
	"./api/core/models/OrganisationOtherNameDTO": 87066,
	"./api/core/models/OrganisationOtherNameDTO.ts": 87066,
	"./api/core/models/OrganisationToPersonDTO": 58523,
	"./api/core/models/OrganisationToPersonDTO.ts": 58523,
	"./api/core/models/PageMetadata": 96232,
	"./api/core/models/PageMetadata.ts": 96232,
	"./api/core/models/PageResponseListWorkDTO": 44994,
	"./api/core/models/PageResponseListWorkDTO.ts": 44994,
	"./api/core/models/PagedModelConfigResponse": 39853,
	"./api/core/models/PagedModelConfigResponse.ts": 39853,
	"./api/core/models/PagedModelPublisherDTO": 66633,
	"./api/core/models/PagedModelPublisherDTO.ts": 66633,
	"./api/core/models/PagedModelPublistMetadata": 96072,
	"./api/core/models/PagedModelPublistMetadata.ts": 96072,
	"./api/core/models/PagedModelWorkDTO": 97476,
	"./api/core/models/PagedModelWorkDTO.ts": 97476,
	"./api/core/models/PatchDocument": 90079,
	"./api/core/models/PatchDocument.ts": 90079,
	"./api/core/models/PersonDTO": 29006,
	"./api/core/models/PersonDTO.ts": 29006,
	"./api/core/models/PersonEmailDTO": 45146,
	"./api/core/models/PersonEmailDTO.ts": 45146,
	"./api/core/models/PersonInstitutionalIdDTO": 1052,
	"./api/core/models/PersonInstitutionalIdDTO.ts": 1052,
	"./api/core/models/PersonNameDTO": 87483,
	"./api/core/models/PersonNameDTO.ts": 87483,
	"./api/core/models/PersonStatusDTO": 8680,
	"./api/core/models/PersonStatusDTO.ts": 8680,
	"./api/core/models/PersonToOrganisationDTO": 67479,
	"./api/core/models/PersonToOrganisationDTO.ts": 67479,
	"./api/core/models/ProjectDTO": 51032,
	"./api/core/models/ProjectDTO.ts": 51032,
	"./api/core/models/ProjectFundingReferenceDTO": 44414,
	"./api/core/models/ProjectFundingReferenceDTO.ts": 44414,
	"./api/core/models/ProjectFundingReferenceExternalIdentifierDTO": 80270,
	"./api/core/models/ProjectFundingReferenceExternalIdentifierDTO.ts": 80270,
	"./api/core/models/ProjectFundingReferenceFundingStreamDTO": 93425,
	"./api/core/models/ProjectFundingReferenceFundingStreamDTO.ts": 93425,
	"./api/core/models/ProjectFundingReferenceFundingSubstreamDTO": 50557,
	"./api/core/models/ProjectFundingReferenceFundingSubstreamDTO.ts": 50557,
	"./api/core/models/ProjectInstitutionalIdDTO": 95178,
	"./api/core/models/ProjectInstitutionalIdDTO.ts": 95178,
	"./api/core/models/ProjectOtherNameDTO": 79759,
	"./api/core/models/ProjectOtherNameDTO.ts": 79759,
	"./api/core/models/ProjectOtherPartnerDTO": 32324,
	"./api/core/models/ProjectOtherPartnerDTO.ts": 32324,
	"./api/core/models/ProjectPersonOtherDTO": 96107,
	"./api/core/models/ProjectPersonOtherDTO.ts": 96107,
	"./api/core/models/ProjectToPersonDTO": 27356,
	"./api/core/models/ProjectToPersonDTO.ts": 27356,
	"./api/core/models/PubListConfig": 61413,
	"./api/core/models/PubListConfig.ts": 61413,
	"./api/core/models/PubListConfigReplacements": 69664,
	"./api/core/models/PubListConfigReplacements.ts": 69664,
	"./api/core/models/PublisherDTO": 86483,
	"./api/core/models/PublisherDTO.ts": 86483,
	"./api/core/models/PublistConfigProjectOrganisation": 93074,
	"./api/core/models/PublistConfigProjectOrganisation.ts": 93074,
	"./api/core/models/PublistMetadata": 91990,
	"./api/core/models/PublistMetadata.ts": 91990,
	"./api/core/models/ReferencedOrganisationDTO": 93958,
	"./api/core/models/ReferencedOrganisationDTO.ts": 93958,
	"./api/core/models/ReferencedPersonDTO": 75359,
	"./api/core/models/ReferencedPersonDTO.ts": 75359,
	"./api/core/models/ReferencedPersonNameDTO": 33706,
	"./api/core/models/ReferencedPersonNameDTO.ts": 33706,
	"./api/core/models/ReferencedProjectDTO": 3631,
	"./api/core/models/ReferencedProjectDTO.ts": 3631,
	"./api/core/models/ReferencedWorkDTO": 85655,
	"./api/core/models/ReferencedWorkDTO.ts": 85655,
	"./api/core/models/SearchFacet": 37823,
	"./api/core/models/SearchFacet.ts": 37823,
	"./api/core/models/SearchRequest": 41441,
	"./api/core/models/SearchRequest.ts": 41441,
	"./api/core/models/SearchRequestSort": 5037,
	"./api/core/models/SearchRequestSort.ts": 5037,
	"./api/core/models/Share": 223,
	"./api/core/models/Share.ts": 223,
	"./api/core/models/ShareRequestBody": 26362,
	"./api/core/models/ShareRequestBody.ts": 26362,
	"./api/core/models/SolrDocument": 54627,
	"./api/core/models/SolrDocument.ts": 54627,
	"./api/core/models/SolrOrganisationReduced": 76632,
	"./api/core/models/SolrOrganisationReduced.ts": 76632,
	"./api/core/models/SolrPersonReduced": 47941,
	"./api/core/models/SolrPersonReduced.ts": 47941,
	"./api/core/models/SolrProjectReduced": 53187,
	"./api/core/models/SolrProjectReduced.ts": 53187,
	"./api/core/models/SolrPublisher": 53912,
	"./api/core/models/SolrPublisher.ts": 53912,
	"./api/core/models/SolrResultSolrOrganisationReduced": 43103,
	"./api/core/models/SolrResultSolrOrganisationReduced.ts": 43103,
	"./api/core/models/SolrResultSolrPersonReduced": 24038,
	"./api/core/models/SolrResultSolrPersonReduced.ts": 24038,
	"./api/core/models/SolrResultSolrProjectReduced": 49114,
	"./api/core/models/SolrResultSolrProjectReduced.ts": 49114,
	"./api/core/models/SolrResultSolrPublisher": 88155,
	"./api/core/models/SolrResultSolrPublisher.ts": 88155,
	"./api/core/models/SolrResultSolrWorkReduced": 40862,
	"./api/core/models/SolrResultSolrWorkReduced.ts": 40862,
	"./api/core/models/SolrWorkReduced": 65517,
	"./api/core/models/SolrWorkReduced.ts": 65517,
	"./api/core/models/SubjectDTO": 40031,
	"./api/core/models/SubjectDTO.ts": 40031,
	"./api/core/models/UrlDTO": 96884,
	"./api/core/models/UrlDTO.ts": 96884,
	"./api/core/models/WorkDTO": 79974,
	"./api/core/models/WorkDTO.ts": 79974,
	"./api/core/models/WorkDateTypeDTO": 24698,
	"./api/core/models/WorkDateTypeDTO.ts": 24698,
	"./api/core/models/WorkDescriptionDTO": 73288,
	"./api/core/models/WorkDescriptionDTO.ts": 73288,
	"./api/core/models/WorkGeoLocationDTO": 34328,
	"./api/core/models/WorkGeoLocationDTO.ts": 34328,
	"./api/core/models/WorkGeoLocationPointDTO": 40382,
	"./api/core/models/WorkGeoLocationPointDTO.ts": 40382,
	"./api/core/models/WorkGeoLocationPolygonDTO": 2670,
	"./api/core/models/WorkGeoLocationPolygonDTO.ts": 2670,
	"./api/core/models/WorkHasPartDTO": 25941,
	"./api/core/models/WorkHasPartDTO.ts": 25941,
	"./api/core/models/WorkIsPartOfDTO": 51494,
	"./api/core/models/WorkIsPartOfDTO.ts": 51494,
	"./api/core/models/WorkIsPartOfOtherDTO": 29332,
	"./api/core/models/WorkIsPartOfOtherDTO.ts": 29332,
	"./api/core/models/WorkKeywordDTO": 68931,
	"./api/core/models/WorkKeywordDTO.ts": 68931,
	"./api/core/models/WorkLanguageDTO": 57460,
	"./api/core/models/WorkLanguageDTO.ts": 57460,
	"./api/core/models/WorkOrganisationDTO": 6412,
	"./api/core/models/WorkOrganisationDTO.ts": 6412,
	"./api/core/models/WorkOrganisationOtherDTO": 13630,
	"./api/core/models/WorkOrganisationOtherDTO.ts": 13630,
	"./api/core/models/WorkOtherTitleDTO": 95082,
	"./api/core/models/WorkOtherTitleDTO.ts": 95082,
	"./api/core/models/WorkPersonDTO": 71257,
	"./api/core/models/WorkPersonDTO.ts": 71257,
	"./api/core/models/WorkPersonOtherDTO": 45845,
	"./api/core/models/WorkPersonOtherDTO.ts": 45845,
	"./api/core/models/WorkPlaceDTO": 4711,
	"./api/core/models/WorkPlaceDTO.ts": 4711,
	"./api/core/models/WorkProjectDTO": 69341,
	"./api/core/models/WorkProjectDTO.ts": 69341,
	"./api/core/models/WorkProjectOtherDTO": 96393,
	"./api/core/models/WorkProjectOtherDTO.ts": 96393,
	"./api/core/models/WorkPublisherDTO": 55254,
	"./api/core/models/WorkPublisherDTO.ts": 55254,
	"./api/core/models/WorkPublisherPlaceDTO": 38807,
	"./api/core/models/WorkPublisherPlaceDTO.ts": 38807,
	"./api/core/models/WorkRelatedIdentifierDTO": 78114,
	"./api/core/models/WorkRelatedIdentifierDTO.ts": 78114,
	"./api/core/models/WorkRelatedIdentifierInternalDTO": 94621,
	"./api/core/models/WorkRelatedIdentifierInternalDTO.ts": 94621,
	"./api/core/models/WorkTitleAbbreviationDTO": 74420,
	"./api/core/models/WorkTitleAbbreviationDTO.ts": 74420,
	"./api/core/models/YearPeriod": 74898,
	"./api/core/models/YearPeriod.ts": 74898,
	"./api/core/models/index": 5004,
	"./api/core/models/index.ts": 5004,
	"./api/core/runtime": 85909,
	"./api/core/runtime.ts": 85909,
	"./api/import": 40179,
	"./api/import/": 40179,
	"./api/import/apis": 43265,
	"./api/import/apis/": 43265,
	"./api/import/apis/ImportManagementServiceApi": 1714,
	"./api/import/apis/ImportManagementServiceApi.ts": 1714,
	"./api/import/apis/ImportServiceApi": 5017,
	"./api/import/apis/ImportServiceApi.ts": 5017,
	"./api/import/apis/SearchServiceApi": 99184,
	"./api/import/apis/SearchServiceApi.ts": 99184,
	"./api/import/apis/index": 43265,
	"./api/import/apis/index.ts": 43265,
	"./api/import/docs/AdminDataWorkAgencyGrantIdDTO.md": 63637,
	"./api/import/docs/AdminDataWorkDTO.md": 75673,
	"./api/import/docs/AdminDataWorkGrantAgencyDTO.md": 10608,
	"./api/import/docs/AdminDataWorkGrantDTO.md": 43041,
	"./api/import/docs/AdminDataWorkOpenAccessDTO.md": 79079,
	"./api/import/docs/AdminDataWorkOpenAccessFundedDTO.md": 28053,
	"./api/import/docs/AdminDataWorkOrcidSyncDTO.md": 36759,
	"./api/import/docs/EnrichmentJobBody.md": 64192,
	"./api/import/docs/EventDTO.md": 53367,
	"./api/import/docs/EventPlaceDTO.md": 59512,
	"./api/import/docs/ExternalIdDTO.md": 6331,
	"./api/import/docs/ImportManagementServiceApi.md": 98193,
	"./api/import/docs/ImportServiceApi.md": 75146,
	"./api/import/docs/JobBody.md": 61315,
	"./api/import/docs/JobDTO.md": 60678,
	"./api/import/docs/JobEntryDTO.md": 44814,
	"./api/import/docs/JobEntryFiltersDTO.md": 38283,
	"./api/import/docs/JobFiltersDTO.md": 51072,
	"./api/import/docs/PageJobDTO.md": 53285,
	"./api/import/docs/PageJobEntryDTO.md": 6339,
	"./api/import/docs/PageableObject.md": 27838,
	"./api/import/docs/PublisherDTO.md": 62163,
	"./api/import/docs/ReferencedOrganisationDTO.md": 15018,
	"./api/import/docs/ReferencedPersonNameDTO.md": 74918,
	"./api/import/docs/ReferencedProjectDTO.md": 29903,
	"./api/import/docs/ReferencedWorkDTO.md": 17127,
	"./api/import/docs/SearchResultDTO.md": 20670,
	"./api/import/docs/SearchServiceApi.md": 19911,
	"./api/import/docs/SortObject.md": 36785,
	"./api/import/docs/SubjectDTO.md": 89639,
	"./api/import/docs/UrlDTO.md": 28052,
	"./api/import/docs/WorkDTO.md": 46706,
	"./api/import/docs/WorkDateTypeDTO.md": 3846,
	"./api/import/docs/WorkDescriptionDTO.md": 57512,
	"./api/import/docs/WorkGeoLocationDTO.md": 51856,
	"./api/import/docs/WorkGeoLocationPointDTO.md": 36962,
	"./api/import/docs/WorkGeoLocationPolygonDTO.md": 53506,
	"./api/import/docs/WorkHasPartDTO.md": 43337,
	"./api/import/docs/WorkIsPartOfDTO.md": 7146,
	"./api/import/docs/WorkIsPartOfOtherDTO.md": 7988,
	"./api/import/docs/WorkKeywordDTO.md": 26555,
	"./api/import/docs/WorkLanguageDTO.md": 732,
	"./api/import/docs/WorkOrganisationDTO.md": 42180,
	"./api/import/docs/WorkOrganisationOtherDTO.md": 3594,
	"./api/import/docs/WorkOtherTitleDTO.md": 3718,
	"./api/import/docs/WorkPersonDTO.md": 87261,
	"./api/import/docs/WorkPersonOtherDTO.md": 16033,
	"./api/import/docs/WorkPlaceDTO.md": 86791,
	"./api/import/docs/WorkProjectDTO.md": 35425,
	"./api/import/docs/WorkProjectOtherDTO.md": 99413,
	"./api/import/docs/WorkPublisherDTO.md": 35730,
	"./api/import/docs/WorkPublisherPlaceDTO.md": 98183,
	"./api/import/docs/WorkRelatedIdentifierDTO.md": 72806,
	"./api/import/docs/WorkRelatedIdentifierInternalDTO.md": 44153,
	"./api/import/docs/WorkTitleAbbreviationDTO.md": 12444,
	"./api/import/index": 40179,
	"./api/import/index.ts": 40179,
	"./api/import/models": 70650,
	"./api/import/models/": 70650,
	"./api/import/models/AdminDataWorkAgencyGrantIdDTO": 97915,
	"./api/import/models/AdminDataWorkAgencyGrantIdDTO.ts": 97915,
	"./api/import/models/AdminDataWorkDTO": 38083,
	"./api/import/models/AdminDataWorkDTO.ts": 38083,
	"./api/import/models/AdminDataWorkGrantAgencyDTO": 13162,
	"./api/import/models/AdminDataWorkGrantAgencyDTO.ts": 13162,
	"./api/import/models/AdminDataWorkGrantDTO": 87387,
	"./api/import/models/AdminDataWorkGrantDTO.ts": 87387,
	"./api/import/models/AdminDataWorkOpenAccessDTO": 3877,
	"./api/import/models/AdminDataWorkOpenAccessDTO.ts": 3877,
	"./api/import/models/AdminDataWorkOpenAccessFundedDTO": 54719,
	"./api/import/models/AdminDataWorkOpenAccessFundedDTO.ts": 54719,
	"./api/import/models/AdminDataWorkOrcidSyncDTO": 90633,
	"./api/import/models/AdminDataWorkOrcidSyncDTO.ts": 90633,
	"./api/import/models/EnrichmentJobBody": 38806,
	"./api/import/models/EnrichmentJobBody.ts": 38806,
	"./api/import/models/EventDTO": 51257,
	"./api/import/models/EventDTO.ts": 51257,
	"./api/import/models/EventPlaceDTO": 52514,
	"./api/import/models/EventPlaceDTO.ts": 52514,
	"./api/import/models/ExternalIdDTO": 35857,
	"./api/import/models/ExternalIdDTO.ts": 35857,
	"./api/import/models/JobBody": 42865,
	"./api/import/models/JobBody.ts": 42865,
	"./api/import/models/JobDTO": 97712,
	"./api/import/models/JobDTO.ts": 97712,
	"./api/import/models/JobEntryDTO": 6564,
	"./api/import/models/JobEntryDTO.ts": 6564,
	"./api/import/models/JobEntryFiltersDTO": 35693,
	"./api/import/models/JobEntryFiltersDTO.ts": 35693,
	"./api/import/models/JobFiltersDTO": 93089,
	"./api/import/models/JobFiltersDTO.ts": 93089,
	"./api/import/models/PageJobDTO": 64931,
	"./api/import/models/PageJobDTO.ts": 64931,
	"./api/import/models/PageJobEntryDTO": 31265,
	"./api/import/models/PageJobEntryDTO.ts": 31265,
	"./api/import/models/PageableObject": 6048,
	"./api/import/models/PageableObject.ts": 6048,
	"./api/import/models/PublisherDTO": 21145,
	"./api/import/models/PublisherDTO.ts": 21145,
	"./api/import/models/ReferencedOrganisationDTO": 92948,
	"./api/import/models/ReferencedOrganisationDTO.ts": 92948,
	"./api/import/models/ReferencedPersonNameDTO": 9608,
	"./api/import/models/ReferencedPersonNameDTO.ts": 9608,
	"./api/import/models/ReferencedProjectDTO": 35893,
	"./api/import/models/ReferencedProjectDTO.ts": 35893,
	"./api/import/models/ReferencedWorkDTO": 56457,
	"./api/import/models/ReferencedWorkDTO.ts": 56457,
	"./api/import/models/SearchResultDTO": 83852,
	"./api/import/models/SearchResultDTO.ts": 83852,
	"./api/import/models/SortObject": 1215,
	"./api/import/models/SortObject.ts": 1215,
	"./api/import/models/SubjectDTO": 25705,
	"./api/import/models/SubjectDTO.ts": 25705,
	"./api/import/models/UrlDTO": 40594,
	"./api/import/models/UrlDTO.ts": 40594,
	"./api/import/models/WorkDTO": 84852,
	"./api/import/models/WorkDTO.ts": 84852,
	"./api/import/models/WorkDateTypeDTO": 32976,
	"./api/import/models/WorkDateTypeDTO.ts": 32976,
	"./api/import/models/WorkDescriptionDTO": 74238,
	"./api/import/models/WorkDescriptionDTO.ts": 74238,
	"./api/import/models/WorkGeoLocationDTO": 13618,
	"./api/import/models/WorkGeoLocationDTO.ts": 13618,
	"./api/import/models/WorkGeoLocationPointDTO": 85764,
	"./api/import/models/WorkGeoLocationPointDTO.ts": 85764,
	"./api/import/models/WorkGeoLocationPolygonDTO": 48116,
	"./api/import/models/WorkGeoLocationPolygonDTO.ts": 48116,
	"./api/import/models/WorkHasPartDTO": 94231,
	"./api/import/models/WorkHasPartDTO.ts": 94231,
	"./api/import/models/WorkIsPartOfDTO": 17636,
	"./api/import/models/WorkIsPartOfDTO.ts": 17636,
	"./api/import/models/WorkIsPartOfOtherDTO": 11686,
	"./api/import/models/WorkIsPartOfOtherDTO.ts": 11686,
	"./api/import/models/WorkKeywordDTO": 11437,
	"./api/import/models/WorkKeywordDTO.ts": 11437,
	"./api/import/models/WorkLanguageDTO": 40334,
	"./api/import/models/WorkLanguageDTO.ts": 40334,
	"./api/import/models/WorkOrganisationDTO": 87910,
	"./api/import/models/WorkOrganisationDTO.ts": 87910,
	"./api/import/models/WorkOrganisationOtherDTO": 73780,
	"./api/import/models/WorkOrganisationOtherDTO.ts": 73780,
	"./api/import/models/WorkOtherTitleDTO": 60168,
	"./api/import/models/WorkOtherTitleDTO.ts": 60168,
	"./api/import/models/WorkPersonDTO": 53855,
	"./api/import/models/WorkPersonDTO.ts": 53855,
	"./api/import/models/WorkPersonOtherDTO": 85951,
	"./api/import/models/WorkPersonOtherDTO.ts": 85951,
	"./api/import/models/WorkPlaceDTO": 12941,
	"./api/import/models/WorkPlaceDTO.ts": 12941,
	"./api/import/models/WorkProjectDTO": 79343,
	"./api/import/models/WorkProjectDTO.ts": 79343,
	"./api/import/models/WorkProjectOtherDTO": 44719,
	"./api/import/models/WorkProjectOtherDTO.ts": 44719,
	"./api/import/models/WorkPublisherDTO": 96364,
	"./api/import/models/WorkPublisherDTO.ts": 96364,
	"./api/import/models/WorkPublisherPlaceDTO": 50757,
	"./api/import/models/WorkPublisherPlaceDTO.ts": 50757,
	"./api/import/models/WorkRelatedIdentifierDTO": 94180,
	"./api/import/models/WorkRelatedIdentifierDTO.ts": 94180,
	"./api/import/models/WorkRelatedIdentifierInternalDTO": 55963,
	"./api/import/models/WorkRelatedIdentifierInternalDTO.ts": 55963,
	"./api/import/models/WorkTitleAbbreviationDTO": 10830,
	"./api/import/models/WorkTitleAbbreviationDTO.ts": 10830,
	"./api/import/models/index": 70650,
	"./api/import/models/index.ts": 70650,
	"./api/import/runtime": 43815,
	"./api/import/runtime.ts": 43815,
	"./api/orcid": 32677,
	"./api/orcid/": 32677,
	"./api/orcid/apis": 77751,
	"./api/orcid/apis/": 77751,
	"./api/orcid/apis/AdminApi": 52090,
	"./api/orcid/apis/AdminApi.ts": 52090,
	"./api/orcid/apis/AuthenticateApi": 32116,
	"./api/orcid/apis/AuthenticateApi.ts": 32116,
	"./api/orcid/apis/DefaultApi": 9252,
	"./api/orcid/apis/DefaultApi.ts": 9252,
	"./api/orcid/apis/PublicApi": 10472,
	"./api/orcid/apis/PublicApi.ts": 10472,
	"./api/orcid/apis/SynchronizeApi": 6481,
	"./api/orcid/apis/SynchronizeApi.ts": 6481,
	"./api/orcid/apis/index": 77751,
	"./api/orcid/apis/index.ts": 77751,
	"./api/orcid/docs/AdminApi.md": 24807,
	"./api/orcid/docs/AuthenticateApi.md": 56815,
	"./api/orcid/docs/Connection.md": 93566,
	"./api/orcid/docs/Connections.md": 98293,
	"./api/orcid/docs/DefaultApi.md": 51209,
	"./api/orcid/docs/DisambiguatedOrganization.md": 20000,
	"./api/orcid/docs/DisambiguatedOrganizationExternalIdentifier.md": 78924,
	"./api/orcid/docs/IntegrationModes.md": 75980,
	"./api/orcid/docs/ModelConfiguration.md": 45579,
	"./api/orcid/docs/Organization.md": 76833,
	"./api/orcid/docs/OrganizationAddress.md": 75761,
	"./api/orcid/docs/PublicApi.md": 72355,
	"./api/orcid/docs/QueueJob.md": 43252,
	"./api/orcid/docs/QueueReport.md": 40845,
	"./api/orcid/docs/QueueReports.md": 33864,
	"./api/orcid/docs/SynchronizeApi.md": 77472,
	"./api/orcid/index": 32677,
	"./api/orcid/index.ts": 32677,
	"./api/orcid/models": 91380,
	"./api/orcid/models/": 91380,
	"./api/orcid/models/Connection": 7462,
	"./api/orcid/models/Connection.ts": 7462,
	"./api/orcid/models/Connections": 75717,
	"./api/orcid/models/Connections.ts": 75717,
	"./api/orcid/models/DisambiguatedOrganization": 50220,
	"./api/orcid/models/DisambiguatedOrganization.ts": 50220,
	"./api/orcid/models/DisambiguatedOrganizationExternalIdentifier": 19152,
	"./api/orcid/models/DisambiguatedOrganizationExternalIdentifier.ts": 19152,
	"./api/orcid/models/IntegrationModes": 59760,
	"./api/orcid/models/IntegrationModes.ts": 59760,
	"./api/orcid/models/ModelConfiguration": 81879,
	"./api/orcid/models/ModelConfiguration.ts": 81879,
	"./api/orcid/models/Organization": 92073,
	"./api/orcid/models/Organization.ts": 92073,
	"./api/orcid/models/OrganizationAddress": 35545,
	"./api/orcid/models/OrganizationAddress.ts": 35545,
	"./api/orcid/models/QueueJob": 99144,
	"./api/orcid/models/QueueJob.ts": 99144,
	"./api/orcid/models/QueueReport": 96909,
	"./api/orcid/models/QueueReport.ts": 96909,
	"./api/orcid/models/QueueReports": 53828,
	"./api/orcid/models/QueueReports.ts": 53828,
	"./api/orcid/models/index": 91380,
	"./api/orcid/models/index.ts": 91380,
	"./api/orcid/runtime": 20205,
	"./api/orcid/runtime.ts": 20205,
	"./api/submission": 11358,
	"./api/submission/": 11358,
	"./api/submission/apis": 67074,
	"./api/submission/apis/": 67074,
	"./api/submission/apis/SubmissionServiceApi": 87193,
	"./api/submission/apis/SubmissionServiceApi.ts": 87193,
	"./api/submission/apis/index": 67074,
	"./api/submission/apis/index.ts": 67074,
	"./api/submission/docs/SubmissionServiceApi.md": 97362,
	"./api/submission/index": 11358,
	"./api/submission/index.ts": 11358,
	"./api/submission/runtime": 98990,
	"./api/submission/runtime.ts": 98990,
	"./api/vocabulary": 41262,
	"./api/vocabulary/": 41262,
	"./api/vocabulary/apis": 36882,
	"./api/vocabulary/apis/": 36882,
	"./api/vocabulary/apis/VocabularyServiceApi": 38953,
	"./api/vocabulary/apis/VocabularyServiceApi.ts": 38953,
	"./api/vocabulary/apis/index": 36882,
	"./api/vocabulary/apis/index.ts": 36882,
	"./api/vocabulary/docs/Notation.md": 66089,
	"./api/vocabulary/docs/VocabularyAsList.md": 50259,
	"./api/vocabulary/docs/VocabularyAsSet.md": 55679,
	"./api/vocabulary/docs/VocabularyServiceApi.md": 31958,
	"./api/vocabulary/index": 41262,
	"./api/vocabulary/index.ts": 41262,
	"./api/vocabulary/models": 59229,
	"./api/vocabulary/models/": 59229,
	"./api/vocabulary/models/Notation": 78915,
	"./api/vocabulary/models/Notation.ts": 78915,
	"./api/vocabulary/models/VocabularyAsList": 80381,
	"./api/vocabulary/models/VocabularyAsList.ts": 80381,
	"./api/vocabulary/models/VocabularyAsSet": 91357,
	"./api/vocabulary/models/VocabularyAsSet.ts": 91357,
	"./api/vocabulary/models/index": 59229,
	"./api/vocabulary/models/index.ts": 59229,
	"./api/vocabulary/runtime": 89278,
	"./api/vocabulary/runtime.ts": 89278,
	"./index": 29014,
	"./index.tsx": 29014,
	"./log": 55776,
	"./log.ts": 55776,
	"./pages/BaseLayout": 46226,
	"./pages/BaseLayout.tsx": 46226,
	"./pages/Footer": 98190,
	"./pages/Footer.tsx": 98190,
	"./pages/Header": 94916,
	"./pages/Header.tsx": 94916,
	"./pages/Layout": 13421,
	"./pages/Layout.tsx": 13421,
	"./pages/Login": 94860,
	"./pages/Login.tsx": 94860,
	"./pages/Logout": 92413,
	"./pages/Logout.tsx": 92413,
	"./pages/admin/adminAreaSystem/AdminAreaSystem": 15554,
	"./pages/admin/adminAreaSystem/AdminAreaSystem.tsx": 15554,
	"./pages/admin/adminAreaSystem/AdminIndexing": 65114,
	"./pages/admin/adminAreaSystem/AdminIndexing.tsx": 65114,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/AdminAreaOrcid": 7326,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/AdminAreaOrcid.tsx": 7326,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/OrcidResult": 99487,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/OrcidResult.tsx": 99487,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/components/OrcidFailedConnections": 33627,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/components/OrcidFailedConnections.tsx": 33627,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/components/OrcidReports": 53504,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/components/OrcidReports.tsx": 53504,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/components/OrcidSucceededConnections": 51631,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/components/OrcidSucceededConnections.tsx": 51631,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/shared": 35142,
	"./pages/admin/adminAreaSystem/adminAreaOrcid/shared.tsx": 35142,
	"./pages/admin/adminAreaSystem/importManagement/AdminJobEntriesManagement": 53647,
	"./pages/admin/adminAreaSystem/importManagement/AdminJobEntriesManagement.tsx": 53647,
	"./pages/admin/adminAreaSystem/importManagement/AdminJobWrapper": 6963,
	"./pages/admin/adminAreaSystem/importManagement/AdminJobWrapper.tsx": 6963,
	"./pages/admin/adminAreaSystem/importManagement/AdminJobsManagement": 68340,
	"./pages/admin/adminAreaSystem/importManagement/AdminJobsManagement.tsx": 68340,
	"./pages/admin/adminAreaUser/AdminAreaUser": 16722,
	"./pages/admin/adminAreaUser/AdminAreaUser.tsx": 16722,
	"./pages/admin/mathjaxTest/AdminMathjaxTest": 81373,
	"./pages/admin/mathjaxTest/AdminMathjaxTest.tsx": 81373,
	"./pages/components/CitationDialog": 24003,
	"./pages/components/CitationDialog.tsx": 24003,
	"./pages/components/CustomBadge": 21224,
	"./pages/components/CustomBadge.tsx": 21224,
	"./pages/components/DuplicateDialog": 91985,
	"./pages/components/DuplicateDialog.tsx": 91985,
	"./pages/components/EmbeddedSearchbar": 6431,
	"./pages/components/EmbeddedSearchbar.tsx": 6431,
	"./pages/components/Error": 87028,
	"./pages/components/Error.tsx": 87028,
	"./pages/components/ExternalLink": 94493,
	"./pages/components/ExternalLink.tsx": 94493,
	"./pages/components/HelpToolTip": 51564,
	"./pages/components/HelpToolTip.tsx": 51564,
	"./pages/components/HierarchyBlock": 99084,
	"./pages/components/HierarchyBlock.tsx": 99084,
	"./pages/components/HierarchyToolTip": 52626,
	"./pages/components/HierarchyToolTip.tsx": 52626,
	"./pages/components/HierarchyToolTipFacet": 20893,
	"./pages/components/HierarchyToolTipFacet.tsx": 20893,
	"./pages/components/InlineIcon": 69112,
	"./pages/components/InlineIcon.tsx": 69112,
	"./pages/components/InternalLink": 80079,
	"./pages/components/InternalLink.tsx": 80079,
	"./pages/components/Label": 4752,
	"./pages/components/Label.tsx": 4752,
	"./pages/components/OrganisationHierarchyToolTip": 12604,
	"./pages/components/OrganisationHierarchyToolTip.tsx": 12604,
	"./pages/components/ParsedMathJax": 51712,
	"./pages/components/ParsedMathJax.tsx": 51712,
	"./pages/components/ProjectHierarchyToolTip": 80507,
	"./pages/components/ProjectHierarchyToolTip.tsx": 80507,
	"./pages/components/QuoteIcon": 81689,
	"./pages/components/QuoteIcon.tsx": 81689,
	"./pages/components/RedirectComputedPath": 23864,
	"./pages/components/RedirectComputedPath.tsx": 23864,
	"./pages/components/Stamp": 90859,
	"./pages/components/Stamp.tsx": 90859,
	"./pages/components/UserAvatar": 80690,
	"./pages/components/UserAvatar.tsx": 80690,
	"./pages/components/debug/debug-menu": 75077,
	"./pages/components/debug/debug-menu.ts": 75077,
	"./pages/components/debug/demologin": 55646,
	"./pages/components/debug/demologin.ts": 55646,
	"./pages/components/form/Labelled": 75918,
	"./pages/components/form/Labelled.tsx": 75918,
	"./pages/components/form/LabelledCalendar": 79368,
	"./pages/components/form/LabelledCalendar.tsx": 79368,
	"./pages/components/form/LabelledChips": 19221,
	"./pages/components/form/LabelledChips.tsx": 19221,
	"./pages/components/form/LabelledDropdown": 4321,
	"./pages/components/form/LabelledDropdown.tsx": 4321,
	"./pages/components/form/LabelledInputNumber": 42023,
	"./pages/components/form/LabelledInputNumber.tsx": 42023,
	"./pages/components/form/LabelledInputText": 18769,
	"./pages/components/form/LabelledInputText.tsx": 18769,
	"./pages/components/form/LabelledInputTextarea": 54074,
	"./pages/components/form/LabelledInputTextarea.tsx": 54074,
	"./pages/components/form/LabelledMultiSelect": 66167,
	"./pages/components/form/LabelledMultiSelect.tsx": 66167,
	"./pages/components/form/LabelledOrganisationSuggester": 52793,
	"./pages/components/form/LabelledOrganisationSuggester.tsx": 52793,
	"./pages/components/form/LabelledPersonSuggester": 14158,
	"./pages/components/form/LabelledPersonSuggester.tsx": 14158,
	"./pages/components/form/LabelledProjectSuggester": 75468,
	"./pages/components/form/LabelledProjectSuggester.tsx": 75468,
	"./pages/components/form/LabelledPublisherSuggester": 96989,
	"./pages/components/form/LabelledPublisherSuggester.tsx": 96989,
	"./pages/components/form/LabelledWorkSuggester": 51438,
	"./pages/components/form/LabelledWorkSuggester.tsx": 51438,
	"./pages/components/form/LabelledYear": 17373,
	"./pages/components/form/LabelledYear.tsx": 17373,
	"./pages/components/form/MultiInput": 58887,
	"./pages/components/form/MultiInput/": 58887,
	"./pages/components/form/MultiInput/Buttons": 6340,
	"./pages/components/form/MultiInput/Buttons.tsx": 6340,
	"./pages/components/form/MultiInput/MultiInputControls": 60140,
	"./pages/components/form/MultiInput/MultiInputControls.tsx": 60140,
	"./pages/components/form/MultiInput/MultiInputControlsProps": 85912,
	"./pages/components/form/MultiInput/MultiInputControlsProps.ts": 85912,
	"./pages/components/form/MultiInput/index": 58887,
	"./pages/components/form/MultiInput/index.tsx": 58887,
	"./pages/components/form/TitledCheckbox": 44714,
	"./pages/components/form/TitledCheckbox.tsx": 44714,
	"./pages/components/form/TitledRadio": 4368,
	"./pages/components/form/TitledRadio.tsx": 4368,
	"./pages/components/form/TitledYesNo": 91481,
	"./pages/components/form/TitledYesNo.tsx": 91481,
	"./pages/components/messages": 61576,
	"./pages/components/messages.tsx": 61576,
	"./pages/dashboard/SearchResults": 89308,
	"./pages/dashboard/SearchResults.test": 54576,
	"./pages/dashboard/SearchResults.test.ts": 54576,
	"./pages/dashboard/SearchResults.tsx": 89308,
	"./pages/dashboard/SearchResultsOrganisation": 83218,
	"./pages/dashboard/SearchResultsOrganisation.tsx": 83218,
	"./pages/dashboard/SearchResultsPerson": 715,
	"./pages/dashboard/SearchResultsPerson.tsx": 715,
	"./pages/dashboard/SearchResultsProject": 35037,
	"./pages/dashboard/SearchResultsProject.tsx": 35037,
	"./pages/dashboard/SearchResultsWork": 4363,
	"./pages/dashboard/SearchResultsWork.tsx": 4363,
	"./pages/dashboard/components/SearchFacets": 53485,
	"./pages/dashboard/components/SearchFacets.tsx": 53485,
	"./pages/dashboard/components/SearchResult": 62370,
	"./pages/dashboard/components/SearchResult.tsx": 62370,
	"./pages/dashboard/components/SearchResultOrganisation": 29052,
	"./pages/dashboard/components/SearchResultOrganisation.tsx": 29052,
	"./pages/dashboard/components/SearchResultPerson": 3889,
	"./pages/dashboard/components/SearchResultPerson.tsx": 3889,
	"./pages/dashboard/components/SearchResultProject": 8807,
	"./pages/dashboard/components/SearchResultProject.tsx": 8807,
	"./pages/dashboard/components/SearchResultWork": 98729,
	"./pages/dashboard/components/SearchResultWork.tsx": 98729,
	"./pages/dashboard/components/SearchResultsList": 76631,
	"./pages/dashboard/components/SearchResultsList.tsx": 76631,
	"./pages/dashboard/searchQueryEscape": 8773,
	"./pages/dashboard/searchQueryEscape.ts": 8773,
	"./pages/dashboard/utils": 39081,
	"./pages/dashboard/utils.tsx": 39081,
	"./pages/detail/DetailOrganisation": 56064,
	"./pages/detail/DetailOrganisation.tsx": 56064,
	"./pages/detail/DetailPerson": 48365,
	"./pages/detail/DetailPerson.tsx": 48365,
	"./pages/detail/DetailProject": 31707,
	"./pages/detail/DetailProject.tsx": 31707,
	"./pages/detail/DetailWork": 24557,
	"./pages/detail/DetailWork.tsx": 24557,
	"./pages/detail/components/ExternalId": 24908,
	"./pages/detail/components/ExternalId.tsx": 24908,
	"./pages/detail/components/InstitutionalId": 81394,
	"./pages/detail/components/InstitutionalId.tsx": 81394,
	"./pages/detail/components/LinkedPerson": 73238,
	"./pages/detail/components/LinkedPerson.tsx": 73238,
	"./pages/detail/components/LinkedPersonOther": 2266,
	"./pages/detail/components/LinkedPersonOther.tsx": 2266,
	"./pages/detail/components/SubjectsRow": 56473,
	"./pages/detail/components/SubjectsRow.tsx": 56473,
	"./pages/detail/components/UrlsRow": 99894,
	"./pages/detail/components/UrlsRow.tsx": 99894,
	"./pages/detail/components/layout/BreakingList": 41970,
	"./pages/detail/components/layout/BreakingList.tsx": 41970,
	"./pages/detail/components/layout/Row": 96853,
	"./pages/detail/components/layout/Row.tsx": 96853,
	"./pages/detail/components/layout/Subrow": 3263,
	"./pages/detail/components/layout/Subrow.tsx": 3263,
	"./pages/detail/components/layout/View": 76582,
	"./pages/detail/components/layout/View.tsx": 76582,
	"./pages/detail/components/layout/renderDetailAccordionTab": 66413,
	"./pages/detail/components/layout/renderDetailAccordionTab.tsx": 66413,
	"./pages/edit/FormContent": 90215,
	"./pages/edit/FormContent.tsx": 90215,
	"./pages/edit/components/LinkedPerson": 8337,
	"./pages/edit/components/LinkedPerson.tsx": 8337,
	"./pages/edit/components/layout/Block": 1289,
	"./pages/edit/components/layout/Block.tsx": 1289,
	"./pages/edit/components/layout/Fieldset": 16516,
	"./pages/edit/components/layout/Fieldset.tsx": 16516,
	"./pages/edit/components/layout/Info": 73660,
	"./pages/edit/components/layout/Info.tsx": 73660,
	"./pages/edit/components/layout/InputGroup": 81529,
	"./pages/edit/components/layout/InputGroup.css": 25773,
	"./pages/edit/components/layout/InputGroup.tsx": 81529,
	"./pages/edit/components/layout/Panel": 74332,
	"./pages/edit/components/layout/Panel.tsx": 74332,
	"./pages/edit/components/parts/EditorialStatus": 75807,
	"./pages/edit/components/parts/EditorialStatus.tsx": 75807,
	"./pages/edit/components/parts/Emails": 34307,
	"./pages/edit/components/parts/Emails.tsx": 34307,
	"./pages/edit/components/parts/EmploymentPeriods": 42634,
	"./pages/edit/components/parts/EmploymentPeriods.tsx": 42634,
	"./pages/edit/components/parts/ExternalIds": 71395,
	"./pages/edit/components/parts/ExternalIds.tsx": 71395,
	"./pages/edit/components/parts/GeoLocations": 89489,
	"./pages/edit/components/parts/GeoLocations.tsx": 89489,
	"./pages/edit/components/parts/Hidden": 92964,
	"./pages/edit/components/parts/Hidden.tsx": 92964,
	"./pages/edit/components/parts/InstitutionalIds": 7381,
	"./pages/edit/components/parts/InstitutionalIds.tsx": 7381,
	"./pages/edit/components/parts/LinkedPersonExtern": 12006,
	"./pages/edit/components/parts/LinkedPersonExtern.tsx": 12006,
	"./pages/edit/components/parts/LinkedPersonIntern": 98192,
	"./pages/edit/components/parts/LinkedPersonIntern.tsx": 98192,
	"./pages/edit/components/parts/LinkedPersonName": 98033,
	"./pages/edit/components/parts/LinkedPersonName.tsx": 98033,
	"./pages/edit/components/parts/LinkedPersonRow": 84250,
	"./pages/edit/components/parts/LinkedPersonRow.tsx": 84250,
	"./pages/edit/components/parts/OrganisationPersons": 85770,
	"./pages/edit/components/parts/OrganisationPersons.tsx": 85770,
	"./pages/edit/components/parts/OtherNames": 90582,
	"./pages/edit/components/parts/OtherNames.tsx": 90582,
	"./pages/edit/components/parts/PersonNames": 96463,
	"./pages/edit/components/parts/PersonNames.tsx": 96463,
	"./pages/edit/components/parts/PersonOrganisations": 85714,
	"./pages/edit/components/parts/PersonOrganisations.tsx": 85714,
	"./pages/edit/components/parts/PersonStatuses": 79533,
	"./pages/edit/components/parts/PersonStatuses.tsx": 79533,
	"./pages/edit/components/parts/ProjectFundingReferences": 8532,
	"./pages/edit/components/parts/ProjectFundingReferences.tsx": 8532,
	"./pages/edit/components/parts/ProjectOtherPartners": 65502,
	"./pages/edit/components/parts/ProjectOtherPartners.tsx": 65502,
	"./pages/edit/components/parts/ReferencedOrganisations": 69092,
	"./pages/edit/components/parts/ReferencedOrganisations.tsx": 69092,
	"./pages/edit/components/parts/ReferencedProjects": 7247,
	"./pages/edit/components/parts/ReferencedProjects.tsx": 7247,
	"./pages/edit/components/parts/Subjects": 3371,
	"./pages/edit/components/parts/Subjects.tsx": 3371,
	"./pages/edit/components/parts/Urls": 62161,
	"./pages/edit/components/parts/Urls.tsx": 62161,
	"./pages/edit/components/parts/WorkDateTypes": 95936,
	"./pages/edit/components/parts/WorkDateTypes.tsx": 95936,
	"./pages/edit/components/parts/WorkIssued": 9144,
	"./pages/edit/components/parts/WorkIssued.tsx": 9144,
	"./pages/edit/components/parts/WorkLanguages": 21858,
	"./pages/edit/components/parts/WorkLanguages.tsx": 21858,
	"./pages/edit/components/parts/WorkOtherTitles": 73192,
	"./pages/edit/components/parts/WorkOtherTitles.tsx": 73192,
	"./pages/edit/components/parts/WorkPublisherAdd": 74818,
	"./pages/edit/components/parts/WorkPublisherAdd.tsx": 74818,
	"./pages/edit/components/parts/WorkPublishers": 23700,
	"./pages/edit/components/parts/WorkPublishers.tsx": 23700,
	"./pages/edit/components/parts/WorkReferencedIdentifierInternal": 17852,
	"./pages/edit/components/parts/WorkReferencedIdentifierInternal.tsx": 17852,
	"./pages/edit/components/parts/WorkReferencingIdentifierInternal": 49935,
	"./pages/edit/components/parts/WorkReferencingIdentifierInternal.tsx": 49935,
	"./pages/edit/components/parts/WorkRelatedIdentifierExternal": 69094,
	"./pages/edit/components/parts/WorkRelatedIdentifierExternal.tsx": 69094,
	"./pages/edit/components/suggester/OrganisationSuggester": 92286,
	"./pages/edit/components/suggester/OrganisationSuggester.tsx": 92286,
	"./pages/edit/components/suggester/PersonSuggester": 93777,
	"./pages/edit/components/suggester/PersonSuggester.tsx": 93777,
	"./pages/edit/components/suggester/ProjectSuggester": 80649,
	"./pages/edit/components/suggester/ProjectSuggester.tsx": 80649,
	"./pages/edit/components/suggester/PublisherSuggester": 8496,
	"./pages/edit/components/suggester/PublisherSuggester.tsx": 8496,
	"./pages/edit/components/suggester/Suggester": 20312,
	"./pages/edit/components/suggester/Suggester.tsx": 20312,
	"./pages/edit/components/suggester/WorkSuggester": 8561,
	"./pages/edit/components/suggester/WorkSuggester.tsx": 8561,
	"./pages/edit/components/suggester/utils": 36000,
	"./pages/edit/components/suggester/utils.tsx": 36000,
	"./pages/edit/organisation/EditOrganisation": 40787,
	"./pages/edit/organisation/EditOrganisation.ts": 40787,
	"./pages/edit/organisation/FormOrganisation": 79915,
	"./pages/edit/organisation/FormOrganisation.tsx": 79915,
	"./pages/edit/person/EditPerson": 94713,
	"./pages/edit/person/EditPerson.ts": 94713,
	"./pages/edit/person/FormPerson": 30365,
	"./pages/edit/person/FormPerson.tsx": 30365,
	"./pages/edit/project/EditProject": 51929,
	"./pages/edit/project/EditProject.ts": 51929,
	"./pages/edit/project/FormProject": 42757,
	"./pages/edit/project/FormProject.tsx": 42757,
	"./pages/edit/work/EditWork": 45121,
	"./pages/edit/work/EditWork.ts": 45121,
	"./pages/edit/work/FormWork": 21845,
	"./pages/edit/work/FormWork.tsx": 21845,
	"./pages/edit/work/pages/AdministrativePage": 61240,
	"./pages/edit/work/pages/AdministrativePage.tsx": 61240,
	"./pages/edit/work/pages/BasicPage": 52120,
	"./pages/edit/work/pages/BasicPage.tsx": 52120,
	"./pages/edit/work/pages/ContentPage": 2777,
	"./pages/edit/work/pages/ContentPage.tsx": 2777,
	"./pages/edit/work/pages/EventsPage": 93517,
	"./pages/edit/work/pages/EventsPage.tsx": 93517,
	"./pages/edit/work/pages/HasPartPage": 21993,
	"./pages/edit/work/pages/HasPartPage.tsx": 21993,
	"./pages/edit/work/pages/IdsPage": 38316,
	"./pages/edit/work/pages/IdsPage.tsx": 38316,
	"./pages/edit/work/pages/IsPartOfPage": 94626,
	"./pages/edit/work/pages/IsPartOfPage.tsx": 94626,
	"./pages/edit/work/pages/OrganisationsPage": 84535,
	"./pages/edit/work/pages/OrganisationsPage.tsx": 84535,
	"./pages/edit/work/pages/PersonsPage": 55764,
	"./pages/edit/work/pages/PersonsPage.tsx": 55764,
	"./pages/edit/work/pages/ProjectsPage": 44556,
	"./pages/edit/work/pages/ProjectsPage.tsx": 44556,
	"./pages/edit/work/pages/SpecificPage": 94706,
	"./pages/edit/work/pages/SpecificPage.tsx": 94706,
	"./pages/edit/work/pages/props": 19603,
	"./pages/edit/work/pages/props.ts": 19603,
	"./pages/homepage/Homepage": 31563,
	"./pages/homepage/Homepage.tsx": 31563,
	"./pages/homepage/components/Searchbar": 73082,
	"./pages/homepage/components/Searchbar.tsx": 73082,
	"./pages/homepage/components/Statistics": 6976,
	"./pages/homepage/components/Statistics.tsx": 6976,
	"./pages/homepage/types": 99447,
	"./pages/homepage/types.ts": 99447,
	"./pages/import/Import": 23782,
	"./pages/import/Import.tsx": 23782,
	"./pages/profile/Profile": 44734,
	"./pages/profile/Profile.tsx": 44734,
	"./pages/profile/UserChip": 42790,
	"./pages/profile/UserChip.tsx": 42790,
	"./pages/profile/publists/EmbeddingDialog": 8123,
	"./pages/profile/publists/EmbeddingDialog.tsx": 8123,
	"./pages/profile/publists/LabelledUserSuggester": 93083,
	"./pages/profile/publists/LabelledUserSuggester.tsx": 93083,
	"./pages/profile/publists/Publists": 84394,
	"./pages/profile/publists/Publists.tsx": 84394,
	"./pages/profile/publists/ShareDialog": 53785,
	"./pages/profile/publists/ShareDialog.tsx": 53785,
	"./pages/profile/publists/UserSuggester": 28524,
	"./pages/profile/publists/UserSuggester.tsx": 28524,
	"./pages/publig/PublicationListEditor": 40132,
	"./pages/publig/PublicationListEditor.tsx": 40132,
	"./pages/publig/components/FilterByCreated": 16659,
	"./pages/publig/components/FilterByCreated.tsx": 16659,
	"./pages/publig/components/FilterByYear": 16240,
	"./pages/publig/components/FilterByYear.tsx": 16240,
	"./pages/publig/components/TitledAutoComplete": 41256,
	"./pages/publig/components/TitledAutoComplete.tsx": 41256,
	"./pages/publig/types": 5262,
	"./pages/publig/types.ts": 5262,
	"./pages/publigDocumentation/PublicDocumentation": 14978,
	"./pages/publigDocumentation/PublicDocumentation.tsx": 14978,
	"./pages/settings/Settings": 64494,
	"./pages/settings/Settings.tsx": 64494,
	"./pages/settings/orcid/ConnectOrcidFormData": 14888,
	"./pages/settings/orcid/ConnectOrcidFormData.ts": 14888,
	"./pages/settings/orcid/OrcidGrandRightsForm": 80127,
	"./pages/settings/orcid/OrcidGrandRightsForm.tsx": 80127,
	"./pages/settings/orcid/OrcidLinked": 54219,
	"./pages/settings/orcid/OrcidLinked.tsx": 54219,
	"./pages/settings/orcid/OrcidNotLinked": 45542,
	"./pages/settings/orcid/OrcidNotLinked.tsx": 45542,
	"./pages/settings/orcid/OrcidRevokeRightsForm": 97633,
	"./pages/settings/orcid/OrcidRevokeRightsForm.tsx": 97633,
	"./pages/system/ErrorPage": 15866,
	"./pages/system/ErrorPage.tsx": 15866,
	"./pages/system/Loading": 81045,
	"./pages/system/Loading.tsx": 81045,
	"./pages/upload/Upload": 56626,
	"./pages/upload/Upload.tsx": 56626,
	"./react-app-env.d": 64027,
	"./react-app-env.d.ts": 64027,
	"./routing/ProtectedRoute": 92692,
	"./routing/ProtectedRoute.tsx": 92692,
	"./routing/Routing": 65663,
	"./routing/Routing.tsx": 65663,
	"./serviceWorker": 79835,
	"./serviceWorker.ts": 79835,
	"./util/actions/organisation-actions": 64881,
	"./util/actions/organisation-actions.tsx": 64881,
	"./util/actions/person-actions": 61900,
	"./util/actions/person-actions.tsx": 61900,
	"./util/actions/project-actions": 52792,
	"./util/actions/project-actions.tsx": 52792,
	"./util/actions/work-actions": 31988,
	"./util/actions/work-actions.tsx": 31988,
	"./util/cleanArray": 31765,
	"./util/cleanArray.ts": 31765,
	"./util/intl.utils": 78155,
	"./util/intl.utils.ts": 78155,
	"./util/localization-utils": 67310,
	"./util/localization-utils.tsx": 67310,
	"./util/mandant-settings-utils": 37870,
	"./util/mandant-settings-utils.ts": 37870,
	"./util/mappers/PersonDtoToReferencedPersonDto": 23478,
	"./util/mappers/PersonDtoToReferencedPersonDto.ts": 23478,
	"./util/mappers/PersonNameDtoToReferencedPersonNameDto": 63336,
	"./util/mappers/PersonNameDtoToReferencedPersonNameDto.ts": 63336,
	"./util/orcid.utils": 53423,
	"./util/orcid.utils.ts": 53423,
	"./util/providers/StateProvider": 16370,
	"./util/providers/StateProvider.tsx": 16370,
	"./util/providers/ToastProvider": 40320,
	"./util/providers/ToastProvider.tsx": 40320,
	"./util/providers/state-provider-utils": 39165,
	"./util/providers/state-provider-utils.ts": 39165,
	"./util/pubtype-utils": 45512,
	"./util/pubtype-utils.ts": 45512,
	"./util/require-image": 43532,
	"./util/require-image.ts": 43532,
	"./util/types": 93122,
	"./util/types.ts": 93122,
	"./util/validation/interfaces": 87207,
	"./util/validation/interfaces.ts": 87207,
	"./util/validation/isValid": 67289,
	"./util/validation/isValid.ts": 67289,
	"./util/validation/utils": 45654,
	"./util/validation/utils.ts": 45654,
	"./util/validation/validate": 56397,
	"./util/validation/validate.ts": 56397,
	"./util/validation/validators": 27736,
	"./util/validation/validators.ts": 27736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;